import React, {useState} from "react";
import {sendEnquiry} from "../api/leads";
import "../styles/enquiry.css";

/** "Contact the seller" on a broker's or builder's listing: goes to the listing's broker as a lead (and by email). */
const EnquiryForm = ({propertyId, propertyTitle, sellerLabel = "the seller"}) => {
    const [form, setForm] = useState({name: "", mobile: "", email: "", message: ""});
    const [state, setState] = useState({status: "idle", error: ""});
    const set = (k) => (e) => setForm((f) => ({...f, [k]: e.target.value}));

    const submit = async (e) => {
        e.preventDefault();
        if (form.name.trim().length < 2) return setState({status: "idle", error: "Please enter your name."});
        if (!/^[6-9]\d{9}$/.test(form.mobile.trim())) return setState({status: "idle", error: "Enter a valid 10-digit mobile number."});
        setState({status: "sending", error: ""});
        try {
            await sendEnquiry(propertyId, {
                name: form.name.trim(), mobile: form.mobile.trim(), email: form.email.trim() || null,
                message: form.message.trim() || null,
            });
            setState({status: "sent", error: ""});
        } catch (err) {
            setState({status: "idle", error: err.message});
        }
    };

    if (state.status === "sent") {
        return (
            <div className="enq enq--sent" role="status">
                <h2>Thanks, {form.name.split(" ")[0]}!</h2>
                <p>Your enquiry about {propertyTitle} has been sent. {sellerLabel[0].toUpperCase() + sellerLabel.slice(1)} will contact you on {form.mobile}.</p>
            </div>
        );
    }

    return (
        <form className="enq" onSubmit={submit} noValidate>
            <h2>Contact {sellerLabel}</h2>
            <p className="enq__sub">Ask about price, availability or a site visit. Your number goes only to {sellerLabel}.</p>
            <div className="enq__grid">
                <label><span>Name</span><input value={form.name} onChange={set("name")} autoComplete="name" maxLength={150}/></label>
                <label><span>Mobile</span><input value={form.mobile} onChange={set("mobile")} inputMode="numeric" maxLength={10}
                                                 autoComplete="tel-national" placeholder="10-digit mobile"/></label>
                <label className="enq__wide"><span>Email (optional)</span><input type="email" value={form.email} onChange={set("email")} autoComplete="email"/></label>
                <label className="enq__wide"><span>Message (optional)</span>
                    <textarea rows={3} maxLength={2000} value={form.message} onChange={set("message")}
                              placeholder={`Hi, I'm interested in ${propertyTitle}. Is it available?`}/></label>
            </div>
            {state.error && <p className="enq__error" role="alert">{state.error}</p>}
            <button type="submit" className="enq__btn" disabled={state.status === "sending"}>
                {state.status === "sending" ? "Sending…" : "Send enquiry"}
            </button>
        </form>
    );
};

export default EnquiryForm;
